import React from 'react';
import { useCurrency } from '../hooks/useCurrency';
interface PriceDisplayProps {
  amount: number;
  className?: string;
}
export function PriceDisplay({
  amount,
  className = ''
}: PriceDisplayProps) {
  const symbol = useCurrency();
  // Format with dot as thousands separator (Argentine format)
  const formattedAmount = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return <span className={className} data-id="element-179">
      ARS {symbol}
      {formattedAmount}
    </span>;
}